module.exports = {
  "dateRange": function dateRange(args) {
    return "".concat(args.startDate, " do ").concat(args.endDate);
  },
  "dateSelected": function dateSelected(args) {
    return "".concat(args.date, " odabran");
  },
  "finishRangeSelectionPrompt": "Kliknite da dovr\u0161ite raspon odabranih datuma",
  "maximumDate": "Posljednji raspolo\u017Eivi datum",
  "minimumDate": "Prvi raspolo\u017Eivi datum",
  "next": "Sljede\u0107i",
  "previous": "Prethodni",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Odabrani datum: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Odabrani raspon: ".concat(args.dateRange);
  },
  "startRangeSelectionPrompt": "Kliknite da zapo\u010Dnete raspon odabranih datuma",
  "todayDate": function todayDate(args) {
    return "Danas, ".concat(args.date);
  },
  "todayDateSelected": function todayDateSelected(args) {
    return "Danas, odabran ".concat(args.date);
  }
};